import React, { useEffect, useRef, useState } from 'react';
import styles from '../Step3/Step3.module.css';
import Slider from 'react-slick';
import { buildGreetingVariants } from '../../../utils/greetingVariants';
import detectPlatform from '../../../utils/detectPlatform';

// Keyboard wala scroll sirf native app (Android/iOS WebView) ke liye hai.
// Browser me focus par browser khud element ko view me le aata hai.
const isMobileApp = () => {
  const platform = detectPlatform();
  return platform === 'android' || platform === 'ios';
};

const avatars = {
  Male: [
    { img: 'images/Male-01.png' },
    { img: 'images/Male-02.png' },
    { img: 'images/Male-03.png' },
    { img: 'images/Male-04.png' },
    { img: 'images/Male-05.png' },
  ],
  Female: [
    { img: 'images/Female-01.png' },
    { img: 'images/Female-02.png' },
    { img: 'images/Female-03.png' },
    { img: 'images/Female-04.png' },
    { img: 'images/Female-05.png' },
    { img: 'images/Female-06.png' },
    { img: 'images/Female-07.png' },
    { img: 'images/Female-08.png' },
    { img: 'images/Female-09.png' },
    { img: 'images/Female-10.png' },
    { img: 'images/Female-11.png' },
    { img: 'images/Female-12.png' },
    { img: 'images/Female-13.png' },
    { img: 'images/Female-14.png' },
    { img: 'images/Female-16.png' },
  ],
};

const GREETING_MAX_LENGTH = 300;

const Step3 = ({ onValidationChange, originalRole, originalName, originalAvatar, originalGreeting, isGender, businessName }) => {
  const sliderRef = useRef(null);
  const [agentName, setAgentName] = useState('');
  const [greetingText, setGreetingText] = useState('');
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [agentNameError, setAgentNameError] = useState('');
  /*
   * "default" — koi line pin nahi; customGreeting khaali rehti hai aur backend
   *             ka getGreetingSection() prompt me teen natural variations daal
   *             deta hai (business + agent ka naam bhar kar).
   * "custom"  — user ki apni line.
   */
  const [greetingChoice, setGreetingChoice] = useState('default');
  const [customGreetingText, setCustomGreetingText] = useState('');
  const customGreetingBoxRef = useRef(null);
  const greetingTextareaRef = useRef(null);
  const [gender, setGender] = useState(sessionStorage.getItem('agentGender'));
  const [availableAvatars, setAvailableAvatars] = useState([]);
  const [scale, setScale] = useState(1);
  const [avtarChecked, setAvtarChecked] = useState('');
  const [agentNote, setAgentNote] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [loading, setLoading] = useState(false);
  const listRef = useRef(null);
  const isIphone = /iPhone|iPod/i.test(navigator.userAgent);

  // Sirf Default card me dikhane ke liye. Naam isi screen par edit hota hai, to
  // agentName badalte hi ye lines bhi update ho jaati hain.
  const greetingVariants = buildGreetingVariants(businessName, agentName, originalRole);

  useEffect(() => {
    const storedGender = sessionStorage.getItem("agentGender");
    const storedAgentName = sessionStorage.getItem("agentName")
      || localStorage.getItem("VoiceAgentName") || "";
    const localVoiceName = sessionStorage.getItem("VoiceAgentName") || "";
    // ✅ isGender prop ko priority do, fir session, fir fallback
    const rawGender = isGender || storedGender || "Female";

    // ✅ Safe gender with fallback
    const resolvedGender = rawGender.charAt(0).toUpperCase() + rawGender.slice(1).toLowerCase();

    sessionStorage.setItem("agentGender", resolvedGender.toLowerCase());

    // ✅ Safe avatar list with fallback
    const genderAvatars = avatars[resolvedGender] || avatars["Female"];

    setGender(resolvedGender);
    setAvailableAvatars(genderAvatars);

    // Set agent name
    if (storedAgentName) {
      setAgentName(storedAgentName);
    } else {
      setAgentName(localVoiceName);
      sessionStorage.setItem("agentName", localVoiceName);
    }

    // Set custom greeting
    const storedGreeting = sessionStorage.getItem("customGreeting") || originalGreeting || "";
    setGreetingText(storedGreeting);
    sessionStorage.setItem("customGreeting", storedGreeting);

    /*
     * Kaun sa card highlight hoga, ye seedha greeting ke text se tay hota hai:
     * line pin hai to "Custom", khaali hai to "Default". greetingChoice column
     * (DB) bhi yahi kehta hai, isliye alag se padhne ki zaroorat nahi. Yahan
     * kuch likha nahi jaata (sirf UI state) taaki screen khulte hi form dirty
     * na ho jaaye.
     */
    if (storedGreeting.trim()) {
      setGreetingChoice("custom");
      setCustomGreetingText(storedGreeting);
    } else {
      setGreetingChoice("default");
    }

    // ✅ Use originalAvatar prop as source of truth (comes from DB via parent)
    const avatarToSelect = originalAvatar || null;

    if (avatarToSelect) {
      const avatarIndex = genderAvatars.findIndex(av => av.img === avatarToSelect);

      if (avatarIndex !== -1) {
        const matchedAvatar = genderAvatars[avatarIndex];
        setSelectedAvatar(matchedAvatar);
        sessionStorage.setItem("avatar", matchedAvatar.img);
        setTimeout(() => {
          sliderRef.current?.slickGoTo(avatarIndex);
        }, 50);
        // ✅ isGender aaya hai matlab gender change hua — hamesha dirty
        onValidationChange?.({ isDirty: isGender ? true : false });
      } else {
        const firstAvatar = genderAvatars[0];
        setSelectedAvatar(null);

        sessionStorage.setItem("avatar", firstAvatar.img);
        setTimeout(() => sliderRef.current?.slickGoTo(0), 100);
        onValidationChange?.({ isDirty: true });
      }
    } else {
      const firstAvatar = genderAvatars[0];
      setSelectedAvatar(null);

      sessionStorage.setItem("avatar", firstAvatar.img);
      setTimeout(() => sliderRef.current?.slickGoTo(0), 100);
      onValidationChange?.({ isDirty: true });
    }
  }, []); // originalAvatar comes via key-based remount from parent — no need in deps

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      let newScale = 1 - Math.min(scrollY / 400, 0.3);
      if (newScale < 0.7) newScale = 0.7;
      setScale(newScale);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const triggerValidation = (avatarPath, nameVal, greetingVal) => {
    const currentAvatarPath = avatarPath !== undefined ? avatarPath : (sessionStorage.getItem('avatar') || selectedAvatar?.img || '');
    const currentNameVal = nameVal !== undefined ? nameVal : (sessionStorage.getItem('agentName') || agentName || '');
    const currentGreetingVal = greetingVal !== undefined ? greetingVal : (sessionStorage.getItem('customGreeting') || greetingText || '');

    const avatarDirty = isGender ? true : currentAvatarPath !== originalAvatar;
    const nameDirty = currentNameVal !== (originalName || '');
    const greetingDirty = currentGreetingVal !== (originalGreeting || '');
    const isDirty = avatarDirty || nameDirty || greetingDirty;

    // Greeting khaali hona ab valid hai — matlab "Default" chuna gaya hai, jismein
    // backend khud teeno natural variations prompt me daalta hai. Sirf avatar aur
    // naam zaroori hain.
    const isValid = Boolean(
      currentAvatarPath &&
      currentNameVal && currentNameVal.trim().length > 0
    );

    onValidationChange?.({ isDirty, isValid });
  };

  const handleAvatarChange = (avatar) => {
    setSelectedAvatar(avatar);
    sessionStorage.setItem('avatar', avatar.img);
    setAvtarChecked(true);

    triggerValidation(avatar.img, undefined, undefined);
  };

  const handleAgentNameChange = (e) => {
    const val = e.target.value;
    setAgentName(val);
    sessionStorage.setItem('agentName', val);
    if (!val.trim()) {
      setAgentNameError('Agent Name is required');
    } else {
      setAgentNameError('');
    }

    triggerValidation(undefined, val, undefined);
  };

  /*
   * Ek hi jagah se tay hota hai ki actually kya save hoga — line aur uska intent.
   * Custom select hai par likha kuch nahi, to wo default hi hai: khaali greeting
   * jaati hai aur backend apni teen natural variations prompt me daal deta hai.
   */
  const applyGreeting = (choice, text) => {
    const isRealCustom = choice === 'custom' && text.trim();
    const resolved = isRealCustom ? text.trim() : '';

    setGreetingText(resolved);
    sessionStorage.setItem('customGreeting', resolved);
    sessionStorage.setItem('greetingChoice', isRealCustom ? 'custom' : 'default');
    triggerValidation(undefined, undefined, resolved);
  };

  const handleGreetingChoice = (choice) => {
    setGreetingChoice(choice);
    applyGreeting(choice, customGreetingText);
    /*
     * Custom sabse neeche hai — click karte hi textarea me focus de dete hain.
     * `preventScroll` NAHI dena: mobile par focus se keyboard khulta hai aur
     * browser khud element ko view me laata hai; preventScroll usi ko rok deta
     * tha, isliye box keyboard ke peeche chhup jaata tha. Keyboard ke baad ka
     * final adjustment onFocus handler karta hai.
     */
    if (choice === 'custom') {
      setTimeout(() => greetingTextareaRef.current?.focus(), 60);
    }
  };

  const scrollCustomGreetingIntoView = () => {
    customGreetingBoxRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  /*
   * Keyboard khulte hi visual viewport chhota ho jaata hai. Focus ke turant baad
   * scroll karenge to purani (badi) height ke hisaab se position bithayenge aur
   * box keyboard ke peeche chala jaayega. Isliye viewport ke resize hone ka
   * intezaar karte hain; resize na aaye (desktop, ya purane browser) to timeout
   * fallback se scroll kar dete hain.
   */
  const handleCustomGreetingFocus = () => {
    // Desktop/mobile browser par keyboard hi nahi uthta (ya browser khud handle
    // kar leta hai) — ye correction sirf native app ke liye chahiye.
    if (!isMobileApp()) return;

    const vv = window.visualViewport;
    if (!vv) {
      setTimeout(scrollCustomGreetingIntoView, 300);
      return;
    }
    const onViewportResize = () => {
      clearTimeout(fallbackTimer);
      vv.removeEventListener('resize', onViewportResize);
      scrollCustomGreetingIntoView();
    };
    const fallbackTimer = setTimeout(() => {
      vv.removeEventListener('resize', onViewportResize);
      scrollCustomGreetingIntoView();
    }, 350);
    vv.addEventListener('resize', onViewportResize);
  };

  const handleGreetingChange = (e) => {
    const val = e.target.value.slice(0, GREETING_MAX_LENGTH);
    setCustomGreetingText(val);
    applyGreeting('custom', val);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const scrollListIntoView = () => {
    if (listRef.current) {
      listRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <div className={styles.sliderContainer}>
        <Slider ref={sliderRef} {...settings}>
          {availableAvatars?.map((avatar, index) => (
            <div key={index} className={styles.slide} id="slideradio">
              <label className={styles.avatarLabel}>
                <input
                  type="checkbox"
                  name="avatar"
                  value={index}
                  checked={selectedAvatar?.img === avatar.img}
                  onChange={() => handleAvatarChange(avatar)}
                  className={styles.radioButton}
                />
                <img
                  src={avatar.img}
                  alt={`Avatar ${index + 1}`}
                  className={styles.avatarImage}
                />
              </label>
              <div className={styles.labReq}>
                <div className={styles.agentInputBox} id='sliderstep'>
                  <label className={styles.agentLabel}>Name Your Virtual Agent</label>
                  <div className={styles.Dblock}>
                    <input
                      type="text"
                      name="agentName"
                      maxLength={14}
                      onChange={handleAgentNameChange}
                      className={styles.agentInput}
                      placeholder="Ex- Smith, Nova"
                      value={agentName}
                      onFocus={() => {
                        if (!isIphone) setTimeout(scrollListIntoView, 300);
                      }}
                      onClick={() => {
                        if (!isIphone) setTimeout(scrollListIntoView, 300);
                      }}
                    />
                  </div>
                </div>
                {agentNameError && (
                  <p className={styles.agenterror}>{agentNameError}</p>
                )}
              </div>
            </div>
          ))}
        </Slider>

        <div className={styles.customBtn}>
          <div className={styles.arrowLeft} onClick={() => sliderRef.current.slickPrev()}>
            <img src="svg/sliderleft.svg" alt="Previous" />
          </div>
          <div className={styles.arrowRight} onClick={() => sliderRef.current.slickNext()}>
            <img src="svg/sliderRight.svg" alt="Next" />
          </div>
        </div>
      </div>
      <div className={styles.agentNoteBox}>
        <div className={styles.greetingBox}>
          <div className={styles.greetingHeader}>
            <label className={styles.agentLabel} style={{ margin: 0 }}>
              Greeting
            </label>
          </div>

          <div className={styles.greetingOptions}>
            <div
              className={`${styles.greetingOption} ${greetingChoice === 'default' ? styles.greetingOptionSelected : ''}`}
              onClick={() => handleGreetingChoice('default')}
            >
              <div className={styles.greetingOptionTextBlock}>
                <p className={styles.greetingOptionTitle}>
                  Default{" "}
                  {greetingVariants.length > 1 && (
                    <span className={styles.greetingDefaultHint}>(1 of these)</span>
                  )}
                </p>
                <ul className={styles.greetingVariantList}>
                  {greetingVariants.map((variant, index) => (
                    <li key={index} className={styles.greetingVariantItem}>
                      {variant}
                    </li>
                  ))}
                </ul>
              </div>
              <span className={styles.greetingRadio}></span>
            </div>

            <div
              className={`${styles.greetingOption} ${greetingChoice === 'custom' ? styles.greetingOptionSelected : ''}`}
              onClick={() => handleGreetingChoice('custom')}
            >
              <div className={styles.greetingOptionTextBlock}>
                <p className={styles.greetingOptionTitle}>Custom greeting</p>
                <p className={styles.greetingOptionSub}>Write your own opening line</p>
              </div>
              <span className={styles.greetingRadio}></span>
            </div>
          </div>

          {greetingChoice === 'custom' && (
            <div className={styles.greetingCustomBox} ref={customGreetingBoxRef}>
              <textarea
                ref={greetingTextareaRef}
                className={styles.greetingTextarea}
                rows={3}
                maxLength={GREETING_MAX_LENGTH}
                placeholder="Enter a custom greeting for your agent..."
                value={customGreetingText}
                onChange={handleGreetingChange}
                onFocus={handleCustomGreetingFocus}
              />
              <div className={styles.greetingFootRow}>
                <span className={styles.greetingHint}>
                  Leave it blank to use the default greeting.
                </span>
                <span className={`${styles.charCount} ${customGreetingText.length >= GREETING_MAX_LENGTH ? styles.charCountLimit : ''}`}>
                  {customGreetingText.length}/{GREETING_MAX_LENGTH}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Step3;